/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Swift_Raw_Cod_AskInputs */

const en_swift_raw_cod_ask = /** @type {(inputs: Swift_Raw_Cod_AskInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Active`)
};

const de_swift_raw_cod_ask = /** @type {(inputs: Swift_Raw_Cod_AskInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktiv`)
};

/**
* | output |
* | --- |
* | "Active" |
*
* @param {Swift_Raw_Cod_AskInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const swift_raw_cod_ask = /** @type {((inputs?: Swift_Raw_Cod_AskInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Swift_Raw_Cod_AskInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_swift_raw_cod_ask(inputs)
	return de_swift_raw_cod_ask(inputs)
});